<template>
    <div
      @click="onLoginWithGoogle"
      class="login-with-google text-center pointer"
    >
      <img
        class="login-img float-left"
        src="@/assets/google.png"
        height="22"
        alt=""
      />
      {{$t('login.loginGoogle')}}
    </div>
</template>

<script>


export default {
  name: 'LoginGoogle',


  data() {
    return {

    };
  },
 
  methods: {
    onLoginWithGoogle() {
      localStorage.setItem('userId', 'social');
      let url = process.env.VUE_APP_BASE_URI + '/auth/google/redirect';
      window.location.href = url;
    },


  },
  mounted() {

  },
};
</script>

<style lang="scss">
@import '@/styles/colors';

.login-with-google {
  border: 1px solid $light-grey;
  border-radius: 5px;
  padding: 5px;
  margin: 10px;
}
</style>
